import React, { useEffect } from 'react'
import Trans from 'next-translate/Trans'
import useTranslation from 'next-translate/useTranslation'
import ReactTooltip from 'react-tooltip'
import useShowDoc from 'tennders-documents/hooks/useShowDoc'
import { apiDelete } from 'tennders-stracture/libs/api'
import GHref from 'tennders-market/common/components/element/GHref'
import { dateToStr } from 'tennders-stracture/libs/utils'
import { get } from 'lodash'
import { AnimatePresence, motion } from 'framer-motion'
import useForm from 'tennders-common/form/hooks/useForm'
import { STATUS_CANCELLED } from 'tennders-stracture/libs/constants'
import useTransactions from 'tennders-transactions/hooks/useTransactions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'

const OrderDocContent = (props) => {
  const {
    document: doc,
    setDocument,
    deleteDoc,
    transaction
  } = props
  const { t } = useTranslation()
  const log = get(doc, 'logs.0')

  useEffect(() => {
    ReactTooltip.rebuild()
  }, [])

  return (
    <div className="d-flex row mt-10" key={doc.id}>
      <div className="mb-4 text-underline">
        <span
          data-tip
          data-for={`tooltip_doc_${doc.id}`}
        >
          <GHref onClick={() => setDocument(doc)}>
            {doc.title === null ? `${t('document:document')} #${doc.id}` : doc.title}
          </GHref>
        </span>
        <ReactTooltip
          id={`tooltip_doc_${doc.id}`}
          className=""
          type="info"
        >
          <span>
            {t('document:document_uploaded_by', {
              createdBy: doc.createdByStr,
              createdAt: dateToStr(new Date(doc.createdAtStr))
            })}
          </span>
          {log && (
            <>
              <br />
              <span>
                {t('document:sentTo', {
                  email: log.email,
                  createdAt: dateToStr(new Date(log.createdAtStr))
                })}
              </span>
            </>
          )}
        </ReactTooltip>
      </div>
      {': '}
      <div className="mb-16 mt-2 ml-4 text-12 italic">
        {log
          ? t('document:sentTo', {
            email: log.email,
            createdAt: dateToStr(new Date(log.createdAtStr))
          })
          : <Trans i18nKey="document:doc_to_be_send" />}
        {doc.deletable && transaction?.status?.label !== STATUS_CANCELLED && (
          <GHref
            onClick={() => deleteDoc(doc.id)}
            className="ml-10 mb-20  "
          >
            <FontAwesomeIcon icon={faXmark} className="mr-4" />
          </GHref>
        )}
      </div>
    </div>
  )
}

const DocumentList = ({
  documents: docs,
  setDocuments: setDocs,
  poc,
  transaction
}) => {
  // const { refreshTransaction } = useTransactions()
  const { t } = useTranslation()
  const { setDocument } = useShowDoc()
  const { handleDelete } = useForm({ initialForm: undefined })
  const { id: transactionId } = transaction
  const { refreshTransaction } = useTransactions()

  const deleteDoc = async (id) => {
    await handleDelete({
      id,
      okMsg: t('tableRow:deletedDocumentMsg'),
      confirmTitle: t('tableRow:deleteDocumentItem'),
      confirmMessage: t('tableRow:deleteDocumentAsk'),
      onOk: async ({ popConfirmSubmitting, popConfirm }) => {
        popConfirmSubmitting(true)
        await apiDelete(`/documents/${id}`, {})
        popConfirmSubmitting(false)
        await refreshTransaction(transactionId)
        popConfirm(false)
        setTimeout(() => {
          setDocs(prev => prev.filter(doc => doc.id !== id))
        }, 120)
      }
    })

    // refreshTransaction(transactionId)
  }

  if (!docs || docs.length === 0) {
    return (
      <p className="text-12 mb-0">
        <Trans i18nKey="document:noDocumentsUploaded" />
      </p>
    )
  }

  return (
    <div>
      <AnimatePresence>
        {docs?.map((doc) => (
          doc.type === 1 ? (
            <OrderDocContent
              deleteDoc={deleteDoc}
              setDocument={() => setDocument({
                ...doc,
                sendAgain: doc.resendable ? '/documents/' + transactionId + '/' + doc.id + '/order-doc/sendAgain' : null
              })}
              key={doc.id}
              poc={poc?.email}
              document={doc}
              transaction={transaction}
            />
          ) : (
            <motion.div
              key={'doc_' + doc.id}
              exit={{ opacity: 0, y: 50, transition: { duration: 0.2, opacity: { duration: 0.09 } } }}
              className="overflow-hidden">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.1, opacity: { duration: 0.09 } }}
                className="d-flex row mt-10"
              >
                <div className="mb-4 text-underline">
                  <GHref onClick={() => setDocument(doc)}>
                    {doc.title === null ? `${t('document:document')} #${doc.id}` : doc.title}
                  </GHref>
                </div>
                {': '}
                <div className="mb-16 mt-2 ml-4 text-12 italic">
                  <Trans i18nKey="document:uploadedBy" />
                  {' '}
                  {doc.createdByStr}
                  {' '}
                  at
                  {' '}
                  {dateToStr(new Date(doc.createdAtStr))}
                  {doc.deletable && transaction?.status?.label !== STATUS_CANCELLED && (
                    <GHref
                      onClick={() => {
                        deleteDoc(doc.id)
                      }}
                      className="ml-10 mb-20"
                    >
                      <FontAwesomeIcon icon={faXmark} className="mr-4" />
                    </GHref>
                  )}
                </div>
              </motion.div>
            </motion.div>
          )
        ))}
      </AnimatePresence>
    </div>
  )
}
export default React.memo(DocumentList)
